module.exports = __webpack_public_path__ + "media/images/logo-c1f1a08298f079f44af070e66b776483.png";